const STORAGE_KEY = 'hd.debug';

/**
 * Auth tracing for the iframe, off unless asked for.
 *
 * Enable with ?debug on the iframe src — the parent controls that URL, so it
 * works against a deployed build without a rebuild — or by setting
 * localStorage['hd.debug'] = '1' from the frame's own console. The URL form
 * persists itself so it survives a recovery reload that drops the param.
 */
const resolveEnabled = (): boolean => {
    let requested = false;
    try {
        requested = new URLSearchParams(window.location.search).has('debug');
    } catch {
        // no window.location to read
    }

    try {
        // Persisting is best-effort: storage is often partitioned in a third-party
        // frame, and failing to remember the flag must not switch it off.
        if (requested) localStorage.setItem(STORAGE_KEY, '1');
        else requested = localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
        // storage unavailable; the URL param alone still enables tracing
    }

    return requested;
};

const enabled = resolveEnabled();

/** Timestamped so a recovery round-trip can be read against the parent's own log. */
export const debug = (scope: string, message: string, detail?: unknown): void => {
    if (!enabled) return;
    const stamp = new Date().toISOString().slice(11, 23);
    // eslint-disable-next-line no-console
    if (detail === undefined) console.log(`${stamp} [${scope}] ${message}`);
    // eslint-disable-next-line no-console
    else console.log(`${stamp} [${scope}] ${message}`, detail);
};
